var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcoWpp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 85,
    height: 85,
    viewBox: "0 0 85 85",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ico-wpp",
    transform: "translate(0.043 -0.099)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-whatsapp",
    "data-name": "Icon awesome-whatsapp",
    d: "M33.844,8.034A19.731,19.731,0,0,0,2.8,31.838L0,42.056,10.458,39.31a19.665,19.665,0,0,0,9.427,2.4h.009A19.915,19.915,0,0,0,39.806,21.984,19.8,19.8,0,0,0,33.844,8.034ZM19.894,38.386A16.366,16.366,0,0,1,11.542,36.1l-.6-.355-6.2,1.626L6.4,31.322,6.006,30.7a16.427,16.427,0,1,1,30.467-8.716A16.578,16.578,0,0,1,19.894,38.386Zm8.992-12.279c-.489-.249-2.914-1.439-3.367-1.6s-.782-.249-1.111.249-1.271,1.6-1.564,1.937-.578.373-1.066.124c-2.9-1.448-4.8-2.586-6.708-5.864-.506-.871.506-.809,1.448-2.692a.913.913,0,0,0-.044-.862c-.124-.249-1.111-2.674-1.519-3.661-.4-.96-.809-.826-1.111-.844-.284-.018-.613-.018-.942-.018a1.826,1.826,0,0,0-1.315.613A5.538,5.538,0,0,0,9.863,17.6a9.656,9.656,0,0,0,2.008,5.1c.249.329,3.474,5.3,8.423,7.446,3.128,1.351,4.354,1.466,5.918,1.235.951-.142,2.914-1.191,3.323-2.346a4.122,4.122,0,0,0,.284-2.346C29.7,26.471,29.374,26.347,28.886,26.107Z",
    transform: "translate(21.845 19.595)",
    fill: "#0d9648"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_24",
    "data-name": "Ellipse 24",
    transform: "translate(-0.043 0.099)",
    fill: "none",
    stroke: "#0d9648",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 42.5,
    cy: 42.5,
    r: 42.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 42.5,
    cy: 42.5,
    r: 42,
    fill: "none"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoWpp);
export default __webpack_public_path__ + "static/media/ico-wpp.9532d51df85553c951a7fe5c32592cdc.svg";
export { ForwardRef as ReactComponent };